/* eslint-disable @mizdra/layout-shift/require-size-attributes */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react';
import { Grid, Box, Hidden } from '@material-ui/core';
import { IconButton, Typography } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';
import { floorNumberWithCommas } from '../../../Utils';
import { clickCta, stashLinkEvent, tooltipHover, } from '../../../../utils/analytics';
import { InfoPerksContext, PerkProgressContext } from '../../../../contexts';
import { links } from '../../../../constants';
import { fallbackImage } from '../../shared/commons';
import { PLCCDrawerDesktop, PLCCDrawerMobile, } from '../../PLCCBanner/PLCCModals';
import { assetsPerks, pkPerkProgress, } from '../../../../constants/ProXtraPerks';
import { useDisplayAmount } from '../../../../utils/PerkOptionsUtil';
var Unlocked = assetsPerks.Unlocked, Error = assetsPerks.Error, CheckBall = assetsPerks.CheckBall, Locked = assetsPerks.Locked, UnlockedExpired = assetsPerks.UnlockedExpired, BadgUnlocked = assetsPerks.BadgUnlocked;
var analytics = {
    pushMyAccountButtonEvent: function (str) { return clickCta(str); },
    PXCCWorkflowSuccessful: function (str) { return stashLinkEvent(str); },
};
export var RenderTooltip = function () { return (React.createElement(React.Fragment, null,
    React.createElement("div", { className: "info-tooltip" },
        React.createElement(IconButton, { icon: InfoFilled, color: "info", onClick: function () { return tooltipHover('program spend'); } }),
        React.createElement("div", { className: "PerkPLCC__toolTip bottom tooltip-text" },
            React.createElement(Typography, { variant: "body-base" },
                React.createElement("span", { className: "sui-font-bold" }, pkPerkProgress.spendText.toolTipTitle),
                React.createElement("br", null),
                React.createElement("br", null),
                pkPerkProgress.spendText.toolTipDesc,
                React.createElement("br", null),
                React.createElement("br", null),
                "For full details, see the\u00A0",
                React.createElement("a", { className: "u__default-link", href: links.faqTermsAndConditions, target: "_blank", rel: "noreferrer" }, links.termsAndConditionsTitle)),
            React.createElement("i", null))))); };
export var RenderProgressSubTitle = function () { return (React.createElement(Grid, { container: true },
    React.createElement(Grid, { item: true, xs: 12 },
        React.createElement(Grid, { className: "perkProgressSpend__progressTitle " }, pkPerkProgress.spendText.subHeading)))); };
export var PerkSpendBox = function () {
    var detailsPlcc = React.useContext(PerkProgressContext).detailsPlcc;
    var year = new Date().getFullYear();
    var SpendValue = detailsPlcc === null || detailsPlcc === void 0 ? void 0 : detailsPlcc.acceleratedAccrual;
    return (React.createElement(Grid, { item: true, xs: 12 },
        React.createElement(Grid, { container: true, className: "currentSpendBox" },
            React.createElement(Grid, { item: true, container: true, direction: "row", justifyContent: "space-between", className: "sui-w-full sui-flex sui-h-8" },
                React.createElement("div", { className: "sui-flex sui-items-center" }, "".concat(year, " Perks Spend: "),
                    React.createElement("span", { className: "" },
                        React.createElement(RenderTooltip, null))),
                React.createElement("span", { className: "currentSpent_Box" },
                    "$",
                    floorNumberWithCommas(SpendValue, 0))))));
};
export var PerkSpendBoxDetails = function () {
    var perksInfo = React.useContext(InfoPerksContext).perksInfo;
    var _a = React.useContext(PerkProgressContext), setPLCCtoggle = _a.setPLCCtoggle, detailsPlcc = _a.detailsPlcc, PLCCtoggle = _a.PLCCtoggle, plccSwitch = _a.plccSwitch;
    var year = new Date().getFullYear();
    var SpendValue = detailsPlcc === null || detailsPlcc === void 0 ? void 0 : detailsPlcc.acceleratedAccrual;
    return (React.createElement(Grid, { item: true, xs: 12 },
        React.createElement(Hidden, { smDown: true },
            React.createElement(PLCCDrawerDesktop, { setTogglePLCC: setPLCCtoggle, togglePlcc: PLCCtoggle, detailsPlcc: detailsPlcc, perksInfo: perksInfo, plccSwitch: plccSwitch })),
        React.createElement(Hidden, { mdUp: true },
            React.createElement(PLCCDrawerMobile, { setTogglePLCC: setPLCCtoggle, togglePlcc: PLCCtoggle, detailsPlcc: detailsPlcc, perksInfo: perksInfo, plccSwitch: plccSwitch, isMobile: true })),
        React.createElement(Grid, { container: true, className: "currentSpendBox", direction: "row", justifyContent: "space-between", alignItems: "center" },
            React.createElement(Grid, { item: true, sm: 9 }, "".concat(year, " Perks Spend: "),
                "$",
                floorNumberWithCommas(SpendValue, 0)),
            React.createElement(Grid, { item: true, sm: 2 },
                React.createElement("button", { type: "button", className: "perkProgressSpend__spendBoxDetails", onClick: function () {
                        analytics.PXCCWorkflowSuccessful('perks: pxcc enrolled: spend details link');
                        setPLCCtoggle(true);
                    } }, "Details")))));
};
export var RenderPerkPLCCSpend = function () {
    var plccSwitch = React.useContext(PerkProgressContext).plccSwitch;
    return plccSwitch ? React.createElement(PerkSpendBoxDetails, null) : React.createElement(PerkSpendBox, null);
};
// export const TestYourPerkOption = (props: any) => {
//   return (
//     <YourPerkOptions
//       currentData={{ item: props.item }}
//       PerkInfo={props.PerkInfo.perkProgressData}
//       choosePerkActivate={props.choosePerkActivate}
//       hideSpinner={hideSpinner}
//       showSpinner={showSpinner}
//     />
//   );
// };
export var SpendLevelExpired = function (_a) {
    var data = _a.data;
    var tierPerks = (data.item || []).tierPerks;
    return (React.createElement(Grid, { item: true, xs: 12, className: "perkProgressSpend__trackerBox" },
        React.createElement(Grid, { className: "perkProgressSpend__trackerImageBox" },
            React.createElement("img", { src: tierPerks[0].perkImageUrl, className: "perkProgressSpend__reddemedGiftcard", onError: fallbackImage, alt: "Top banner, Home Depot store" })),
        React.createElement(Grid, { className: "perkProgressSpend__trackerTitleFuture" },
            React.createElement(Grid, null,
                " ",
                pkPerkProgress.spendText.perkExpired,
                ":"),
            React.createElement(Grid, null, tierPerks[0].expirationTime))));
};
export var SpendLevelUnclaimedExpired = function (_a) {
    var data = _a.data;
    var tierPerks = (data.item || []).tierPerks;
    return (React.createElement(Grid, { item: true, xs: 12, className: "perkProgressSpend__trackerBox" },
        React.createElement(Grid, { className: "perkProgressSpend__trackerImageBox" },
            React.createElement("img", { src: UnlockedExpired, alt: "UnlockedExpired", width: "64px", height: "64px", className: "sui-p-1" })),
        React.createElement(Grid, { className: "perkProgressSpend__trackerTitleFuture" },
            React.createElement(Grid, null,
                " ",
                pkPerkProgress.spendText.perkExpired,
                ":"),
            React.createElement(Grid, null, tierPerks[0].expirationTime))));
};
export var SpendLevelUnclaimed = function (props) {
    var data = props.data, stateData = props.stateData, controlToggle = props.controlToggle, detailsPlcc = props.detailsPlcc, plccSwitch = props.plccSwitch, showUnlockAnimateTier = props.showUnlockAnimateTier, isLoading = props.isLoading;
    var unclaimedPerkClass = 'perkProgressSpend__trackerBoxStatic';
    if (showUnlockAnimateTier && !isLoading) {
        unclaimedPerkClass = unclaimedPerkClass.concat(' spendLevel__unclaimedAnimation');
    }
    var CurrentTierForAnimation = showUnlockAnimateTier && !isLoading ? (React.createElement(SpendLevelCurrentTier, { data: data, stateData: stateData, controlToggle: controlToggle, detailsPlcc: detailsPlcc, plccSwitch: plccSwitch, toggleAnimation: true })) : ('');
    return (React.createElement(React.Fragment, null,
        CurrentTierForAnimation,
        React.createElement(Grid, { item: true, xs: 12, className: unclaimedPerkClass },
            React.createElement(Grid, { className: "perkProgressSpend__trackerImageBox" },
                React.createElement("img", { src: BadgUnlocked, alt: "BadgUnlocked", className: "perkProgressSpend__reddemedGiftcard" })),
            React.createElement(Grid, { className: "perkProgressSpend__trackerTitleFuture" }, pkPerkProgress.spendText.youveEarned))));
};
export var SpendLevelActiveStatus = function (_a) {
    var data = _a.data;
    var tierPerks = (data.item || []).tierPerks;
    var getDisplayAmount = useDisplayAmount();
    return (React.createElement(Grid, { item: true, xs: 12, className: "perkProgressSpend__trackerBox" },
        React.createElement(Grid, { className: "perkProgressSpend__trackerImageBox" },
            React.createElement("img", { src: tierPerks[0].perkImageUrl, className: "perkProgressSpend__reddemedGiftcard", onError: fallbackImage, alt: "Top banner, Home Depot store" })),
        React.createElement(Grid, { className: "perkProgressSpend__trackerAmount" }, getDisplayAmount(tierPerks[0])),
        React.createElement(Grid, { className: "perkProgressSpend__trackerTitlePerkLibrary" }, tierPerks[0].perkTitle.substring(0, 24))));
};
export var SpendLevelRedeemedStatus = function (_a) {
    var data = _a.data;
    var tierPerks = (data.item || []).tierPerks;
    var getDisplayAmount = useDisplayAmount();
    return (React.createElement(Grid, { item: true, xs: 12, className: "perkProgressSpend__trackerBox" },
        React.createElement(Grid, { className: "perkProgressSpend__trackerImageBox" },
            React.createElement("img", { src: tierPerks[0].perkImageUrl, className: "perkProgressSpend__reddemedGiftcard", onError: fallbackImage, alt: "Top banner, Home Depot store" })),
        React.createElement(Grid, { className: "perkProgressSpend__trackerAmount" }, getDisplayAmount(tierPerks[0])),
        React.createElement(Grid, { className: "perkProgressSpend__trackerTitlePerkLibrary" }, tierPerks[0].perkTitle.substring(0, 24)),
        React.createElement(Grid, { className: "perkProgressSpend__reddemedCircleLabel" }, "Redeemed")));
};
export var SpendLevelFutureTier = function (props) {
    var controlToggle = props.controlToggle, plccSwitch = props.plccSwitch, detailsPlcc = props.detailsPlcc;
    var currentAmount;
    if (controlToggle && plccSwitch) {
        currentAmount = (React.createElement("span", { className: "perkProgressSpend__cardLabel" }, floorNumberWithCommas(detailsPlcc.spendForFutureTierPerkWithPxcc, 0)));
    }
    else {
        currentAmount = floorNumberWithCommas(detailsPlcc.spendForFutureTierPerk, 0);
    }
    return (React.createElement(Grid, { item: true, xs: 12, className: "perkProgressSpend__trackerBoxStatic" },
        React.createElement(Grid, { className: "perkProgressSpend__trackerImageBox circleSpendValue " },
            React.createElement("span", { className: controlToggle && plccSwitch ? 'dollarSizeToggle' : 'dollarSize ' }, "$"),
            currentAmount),
        React.createElement(Grid, { className: "perkProgressSpend__trackerTitleFuture" }, pkPerkProgress.spendText.untilThisPerk)));
};
export var SpendLevelCurrentTier = function (props) {
    var controlToggle = props.controlToggle, plccSwitch = props.plccSwitch, detailsPlcc = props.detailsPlcc, toggleAnimation = props.toggleAnimation;
    var currentAmount;
    var trackerBoxStaticClass = 'perkProgressSpend__trackerBoxStatic';
    var remainingSpendValue = controlToggle && plccSwitch
        ? detailsPlcc.spendForNextPerkWithPxcc
        : detailsPlcc.spendForNextPerk;
    if (toggleAnimation) {
        trackerBoxStaticClass = trackerBoxStaticClass.concat(' spendLevel__rewardAnimation');
        remainingSpendValue = 0;
    }
    if (controlToggle && plccSwitch) {
        currentAmount = (React.createElement("span", { className: "perkProgressSpend__cardLabel" }, floorNumberWithCommas(remainingSpendValue, 0)));
    }
    else {
        currentAmount = floorNumberWithCommas(remainingSpendValue, 0);
    }
    return (React.createElement(Grid, { item: true, xs: 12, className: trackerBoxStaticClass },
        React.createElement(Grid, { className: "perkProgressSpend__trackerImageBox circleSpendValue" },
            React.createElement("span", { className: controlToggle && plccSwitch ? 'dollarSizeToggle' : 'dollarSize ' }, "$"),
            currentAmount),
        React.createElement(Grid, { className: "perkProgressSpend__trackerTitleCurrent " }, pkPerkProgress.spendText.untilYour)));
};
var RenderExpiredStatus = function () { return (React.createElement(Grid, { className: "perkProgressSpend__progressCircleStatus" }, pkPerkProgress.spendText.statusPerkExpired)); };
var RenderCongratulationsStatus = function (props) {
    var isUnclaimedPerk = props.isUnclaimedPerk, showUnlockAnimateTier = props.showUnlockAnimateTier, isLoading = props.isLoading;
    var fadeClass = ' perkProgressAnimate__circleStatusFade';
    var progressCircleClass = 'perkProgressSpend__progressCircleStatus';
    if (isUnclaimedPerk && showUnlockAnimateTier && !isLoading) {
        progressCircleClass = progressCircleClass.concat(' perkProgressAnimate__circleCongratsStatus');
    }
    return (React.createElement(React.Fragment, null,
        isUnclaimedPerk && showUnlockAnimateTier && !isLoading ? (React.createElement(RenderUnclockStatus, { fadeClass: fadeClass })) : (''),
        React.createElement(Grid, { className: progressCircleClass }, pkPerkProgress.spendText.statusCong)));
};
var RenderUnclockStatus = function (_a) {
    var fadeClass = _a.fadeClass;
    var unlockStatusClass = 'perkProgressSpend__progressCircleStatus';
    if (fadeClass.length > 0) {
        unlockStatusClass = unlockStatusClass.concat(fadeClass);
    }
    return (React.createElement(Grid, { className: unlockStatusClass }, pkPerkProgress.spendText.statusCircleUnclock));
};
export var RenderSpendStatus = function (props) {
    var showUnlockAnimateTier = props.showUnlockAnimateTier, isLoading = props.isLoading, PerkInfo = props.PerkInfo, data = props.data;
    var _a = data.item || {}, tierPerks = _a.tierPerks, maxThreshold = _a.maxThreshold;
    var currentSpend = PerkInfo.currentYearSpend < maxThreshold;
    var statusActive = tierPerks[0].perkStatus === 'ACTIVE';
    var statusUnclaimed = tierPerks[0].perkStatus === 'UNCLAIMED';
    var expired = tierPerks[0].perkStatus === 'EXPIRED';
    var titleStatus;
    if (expired) {
        titleStatus = React.createElement(RenderExpiredStatus, null);
    }
    else if (statusActive || statusUnclaimed) {
        titleStatus = (React.createElement(RenderCongratulationsStatus, { isUnclaimedPerk: statusUnclaimed, showUnlockAnimateTier: showUnlockAnimateTier, isLoading: isLoading }));
    }
    else if (currentSpend) {
        titleStatus = React.createElement(RenderUnclockStatus, { fadeClass: "" });
    }
    else {
        titleStatus = (React.createElement(RenderCongratulationsStatus, { isUnclaimedPerk: statusUnclaimed }));
    }
    return titleStatus;
};
export var LeftIconExpired = function (_a) {
    var data = _a.data;
    var item = (data || {}).item;
    var tierPerks = (item || []).tierPerks;
    return (React.createElement(Grid, { item: true, className: "process-step-Mark-left" },
        tierPerks[0] && !tierPerks[0].activationTime ? (React.createElement("img", { src: UnlockedExpired, alt: "UnlockedExpired", width: "65px", height: "65px", className: "sui-p-1" })) : (React.createElement("img", { src: CheckBall, alt: "CheckBall", width: "65px", height: "65px" })),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconAmount" },
            ' ',
            "$",
            item.maxThresholdDisplay),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconLabel" },
            React.createElement(Grid, null, pkPerkProgress.spendText.perkExpired),
            React.createElement(Grid, null, "\u00A0"))));
};
export var LeftIconUnclaimedExpired = function (_a) {
    var data = _a.data;
    return (React.createElement(Grid, { item: true, className: "process-step-Mark-left" },
        React.createElement("img", { src: UnlockedExpired, alt: "UnlockedExpired", width: "65px", height: "65px", className: "sui-p-1" }),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconAmount" },
            ' ',
            "$",
            data.item.maxThresholdDisplay),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconLabel" },
            React.createElement(Grid, null, pkPerkProgress.spendText.perkExpired),
            React.createElement(Grid, null, "\u00A0"))));
};
export var IconRedeemed = function (_a) {
    var data = _a.data;
    return (React.createElement(Grid, { item: true, className: "process-step-Mark-left" },
        React.createElement("img", { src: CheckBall, alt: "CheckBall", width: "65px", height: "65px" }),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconAmount" },
            "$",
            data.item.maxThresholdDisplay),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconLabel" },
            React.createElement(Grid, null, "Redeemed"),
            React.createElement(Grid, null, "\u00A0"))));
};
export var RenderAlertMessage = function (_a) {
    var _b;
    var item = _a.item;
    return (React.createElement("div", { className: "perkProgressSpend__alertLeftMessage" },
        React.createElement("div", { className: "alertMessageLeftBorder" }),
        React.createElement("img", { src: Error, alt: "Error", width: "14px", height: "14px" }),
        React.createElement("span", null,
            ((_b = item === null || item === void 0 ? void 0 : item.tierPerks[0]) === null || _b === void 0 ? void 0 : _b.daysLeft) || 0,
            " days left to use your Perk")));
};
export var AlertMessage = function (_a) {
    var data = _a.data;
    return (React.createElement(Grid, { item: true, className: "process-step-Mark-left" },
        React.createElement("img", { src: Unlocked, alt: "Unlocked", width: "65px", height: "65px" }),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconAmount" },
            ' ',
            "$",
            data.item.maxThresholdDisplay),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconLabel" },
            React.createElement(Grid, null,
                pkPerkProgress.spendText.choose,
                " "),
            React.createElement(Grid, null, pkPerkProgress.spendText.yourPerk),
            React.createElement(Grid, null, RenderAlertMessage(data)))));
};
export var LeftPerkInProgress = function (_a) {
    var data = _a.data;
    return (React.createElement(Grid, { item: true, className: "process-step-Mark-left" },
        React.createElement(Grid, { className: "circle5" }),
        React.createElement("img", { src: Locked, alt: "Locked", width: "65px", height: "65px" }),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconAmount" },
            ' ',
            "$",
            data.item.maxThresholdDisplay),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconLabel" },
            React.createElement(Grid, null, pkPerkProgress.spendText.perk),
            React.createElement(Grid, null, pkPerkProgress.spendText.inProgress))));
};
export var LeftIconUnlockedChoosePerk = function (_a) {
    var data = _a.data;
    return (React.createElement(Grid, { item: true, className: "process-step-Mark-left" },
        React.createElement("img", { src: Unlocked, alt: "Unlocked", width: "65px", height: "65px" }),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconAmount" },
            ' ',
            "$",
            data.item.maxThresholdDisplay),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconLabel" },
            React.createElement(Grid, null,
                pkPerkProgress.spendText.choose,
                " "),
            React.createElement(Grid, null, pkPerkProgress.spendText.yourPerk))));
};
export var LeftIconFreerental = function (_a) {
    var data = _a.data;
    var item = (data || {}).item;
    return (React.createElement(Grid, { item: true, className: "process-step-Mark-left" },
        React.createElement("img", { src: CheckBall, alt: "CheckBall", width: "65px", height: "65px" }),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconAmount" },
            ' ',
            "$",
            item.maxThresholdDisplay),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconLabelLibrary" },
            React.createElement(Grid, null, item.tierPerks[0].perkTitle.substring(0, 24)),
            React.createElement(Grid, null, "\u00A0"))));
};
export var RightIconExpired = function (props) {
    var data = props.data, currentDataIndex = props.currentDataIndex, filterData = props.filterData;
    var item = (data || {}).item;
    return (React.createElement(Grid, { item: true, className: "perkProgressSpend__process-step-InPrpgress_right" },
        item.tierPerks[0] && !item.tierPerks[0].activationTime ? (React.createElement("img", { src: UnlockedExpired, alt: "UnlockedExpired", width: "65px", height: "65px", className: "sui-p-1" })) : (React.createElement("img", { src: CheckBall, alt: "CheckBall", width: "65px", height: "65px" })),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconAmount" },
            "$",
            currentDataIndex < filterData.length - 1
                ? filterData[currentDataIndex + 1].maxThresholdDisplay
                : null),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconLabel" },
            React.createElement(Grid, null, pkPerkProgress.spendText.perkExpired),
            React.createElement(Grid, null, "\u00A0"))));
};
export var RightIconunclaimedExpired = function (props) {
    var currentDataIndex = props.currentDataIndex, filterData = props.filterData;
    return (React.createElement(Grid, { item: true, className: "perkProgressSpend__process-step-InPrpgress_right" },
        React.createElement("img", { src: UnlockedExpired, alt: "UnlockedExpired", width: "65px", height: "65px", className: "sui-p-1" }),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconAmount" },
            "$",
            currentDataIndex < filterData.length - 1
                ? filterData[currentDataIndex + 1].maxThresholdDisplay
                : null),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconLabel" },
            React.createElement(Grid, null, pkPerkProgress.spendText.perkExpired),
            React.createElement(Grid, null, "\u00A0"))));
};
export var RightIconCurrentTier = function (props) {
    var currentDataIndex = props.currentDataIndex, filterData = props.filterData;
    return (React.createElement(Grid, { item: true, className: "perkProgressSpend__process-step-InPrpgress_right" },
        React.createElement("img", { src: Locked, alt: "Locked", width: "65px", height: "65px" }),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconAmount" },
            "$",
            currentDataIndex < filterData.length - 1
                ? filterData[currentDataIndex + 1].maxThresholdDisplay
                : null),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconLabelLibrary" },
            React.createElement(Grid, null, "\u00A0\u00A0\u00A0\u00A0\u00A0"),
            React.createElement(Grid, null, "\u00A0\u00A0\u00A0\u00A0\u00A0"))));
};
export var RightIconInProgress = function (props) {
    var currentDataIndex = props.currentDataIndex, filterData = props.filterData;
    return (React.createElement(Grid, { item: true, className: "perkProgressSpend__process-step-InPrpgress_right" },
        React.createElement(Grid, { className: "circle5" }),
        React.createElement("img", { src: Locked, alt: "Locked", width: "65px", height: "65px" }),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconAmount" },
            "$",
            currentDataIndex < filterData.length - 1
                ? filterData[currentDataIndex + 1].maxThresholdDisplay
                : null),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconLabelLibrary" },
            React.createElement(Grid, null, pkPerkProgress.spendText.perk),
            React.createElement(Grid, null, pkPerkProgress.spendText.inProgress))));
};
export var RightIconExpiringAlert = function (props) {
    var data = props.data, currentDataIndex = props.currentDataIndex, filterData = props.filterData;
    return (React.createElement(Grid, { item: true, className: "process-step-Mark-left" },
        React.createElement("img", { src: Unlocked, alt: "Unlocked", width: "65px", height: "65px" }),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconAmount" },
            "$",
            currentDataIndex < filterData.length - 1
                ? filterData[currentDataIndex + 1].maxThresholdDisplay
                : null),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconLabel" },
            React.createElement(Grid, null,
                pkPerkProgress.spendText.choose,
                " "),
            React.createElement(Grid, null, pkPerkProgress.spendText.yourPerk),
            React.createElement(Grid, null, RenderAlertMessage(data)))));
};
export var RightIconDefault = function (props) {
    var currentDataIndex = props.currentDataIndex, filterData = props.filterData;
    return (React.createElement(Grid, { item: true, className: "perkProgressSpend__process-step-InPrpgress_right" },
        React.createElement("img", { src: Unlocked, alt: "Unlocked", width: "65px", height: "65px" }),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconAmount" },
            "$",
            currentDataIndex < filterData.length - 1
                ? filterData[currentDataIndex + 1].maxThresholdDisplay
                : null),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconLabel" },
            React.createElement(Grid, null,
                pkPerkProgress.spendText.choose,
                " "),
            React.createElement(Grid, null, pkPerkProgress.spendText.yourPerk),
            React.createElement(Grid, null, "\u00A0\u00A0\u00A0\u00A0\u00A0"))));
};
export var RightIconRedeemed = function (props) {
    var currentDataIndex = props.currentDataIndex, filterData = props.filterData;
    return (React.createElement(Grid, { item: true, className: "perkProgressSpend__process-step-InPrpgress_right" },
        React.createElement("img", { src: CheckBall, alt: "CheckBall", width: "65px", height: "65px" }),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconAmount" },
            "$",
            currentDataIndex < filterData.length - 1
                ? filterData[currentDataIndex + 1].maxThresholdDisplay
                : null),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconLabel" },
            React.createElement(Grid, null, "Redeemed"),
            React.createElement(Grid, null, "\u00A0"))));
};
export var RightIconActive = function (props) {
    var _a;
    var data = props.data, currentDataIndex = props.currentDataIndex, filterData = props.filterData;
    var item = (data || {}).item;
    return (React.createElement(Grid, { item: true, className: "perkProgressSpend__process-step-InPrpgress_right" },
        React.createElement("img", { src: CheckBall, alt: "CheckBall", width: "65px", height: "65px" }),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconAmount" },
            "$",
            currentDataIndex < filterData.length - 1
                ? filterData[currentDataIndex + 1].maxThresholdDisplay
                : null),
        React.createElement(Grid, { className: "perkProgressSpend__sideIconLabelLibrary" },
            React.createElement(Grid, null, (_a = item.tierPerks[0].perkTitle) === null || _a === void 0 ? void 0 : _a.substring(0, 24)),
            React.createElement(Grid, null, "\u00A0"))));
};
export var MobileLeftIconUnlockedChoosePerk = function () { return (React.createElement(Grid, { item: true, className: "sui-relative" },
    React.createElement(Grid, { className: "mobileLeftAlert" },
        ' ',
        React.createElement("img", { src: Error, alt: "Error" }),
        ' '),
    React.createElement(Grid, { item: true, className: "perkProgressSpend__mobileIcon" },
        React.createElement("img", { src: Unlocked, alt: "Unlocked", width: "48px", height: "48px" })))); };
export var MobileIconFreerental = function () { return (React.createElement(Grid, { item: true, className: "perkProgressSpend__mobileIcon" },
    React.createElement("img", { src: CheckBall, alt: "CheckBall", width: "48px", height: "48px" }))); };
export var MobileLeftCircleInprogress = function () { return (React.createElement(Grid, { item: true, className: "perkProgressSpend__mobileIcon" },
    React.createElement("img", { src: Locked, alt: "Locked", width: "48px", height: "48px" }))); };
export var MobileGenericCircleInprogress = function () { return (React.createElement(Grid, { item: true, className: "perkProgressSpend__mobileIcon" },
    React.createElement(Grid, { className: "circle5" }),
    React.createElement("img", { src: Locked, alt: "Locked", width: "48px", height: "48px" }))); };
export var MobileLeftIconExpired = function (_a) {
    var data = _a.data;
    var item = (data || {}).item;
    return (React.createElement(Grid, { item: true, className: "perkProgressSpend__mobileIcon" }, item.tierPerks[0] && !item.tierPerks[0].activationTime ? (React.createElement("img", { src: UnlockedExpired, alt: "UnlockedExpired", width: "48px", height: "48px", className: "sui-p-1" })) : (React.createElement("img", { src: CheckBall, alt: "CheckBall", width: "48px", height: "48px" }))));
};
export var MobileLeftIconUnclaimedExpired = function () { return (React.createElement(Grid, { item: true, className: "perkProgressSpend__mobileIcon" },
    React.createElement("img", { src: UnlockedExpired, alt: "UnlockedExpired", width: "48px", height: "48px", className: "sui-p-1" }))); };
export var MobileRightIconExpiringAlert = function () { return (React.createElement(Grid, { item: true, className: "sui-relative" },
    React.createElement(Grid, { className: "mobileAlert" },
        React.createElement("img", { src: Error, alt: "Error" }),
        ' '),
    React.createElement(Grid, { item: true, className: "perkProgressSpend__mobileIcon" },
        React.createElement("img", { src: Unlocked, alt: "Unlocked", width: "48px", height: "48px" })))); };
export var MobileRightIconbadgUnlocked = function () { return (React.createElement(Grid, { item: true, className: "perkProgressSpend__mobileIcon" },
    React.createElement("img", { src: Unlocked, alt: "Unlocked", width: "48px", height: "48px" }))); };
export var PreviousSlideClass = 'prev-tier_slide-left-to-right';
var NextSlideClass = 'next-tier_slide-right-to-left';
export var handleSlideTransition = function (direction, setSlideClass) {
    if (!direction)
        return;
    var slideClass = direction === 'prev' ? PreviousSlideClass : NextSlideClass;
    setSlideClass(slideClass);
};
export var RenderSlideItem = function (_a) {
    var classString = _a.classString, children = _a.children;
    return React.createElement(Box, { className: " ".concat(classString) }, children);
};
export var RenderSlideContainer = function (props) {
    var isPrev = props.isPrev, itemClassString = props.itemClassString, children = props.children;
    var childrenGroup = React.Children.toArray(children);
    var containerClass = 'tier-slide-container';
    return (React.createElement(Box, { className: containerClass },
        React.createElement(RenderSlideItem, { classString: itemClassString }, childrenGroup[0]),
        (childrenGroup.length > 1 || isPrev) && (React.createElement(RenderSlideItem, { classString: itemClassString }, childrenGroup[1]))));
};
